import { ArcElement, Chart as ChartJS } from 'chart.js'
import React, { useMemo } from 'react'
import { Doughnut } from 'react-chartjs-2'
import { useTranslation } from 'react-i18next'

import { Info } from '@/components-latest/primitives/Icons'
import Text from '@/components-latest/primitives/Text'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from '@/components-latest/primitives/Tooltip'
import { OrdersPerformanceDisplay } from '@/ducks/performance/utils/ordersPerformanceDerived.utils'

import {
  compileChartData,
  compileLegendData,
  DEFAULT_OPTIONS
} from './helpers/OrdersDoughnut.helpers'
import Styles from './OrdersDoughnut.module.scss'

ChartJS.register(ArcElement)
const OrdersDoughnutChart: React.FC<{
  ordersPerformance: OrdersPerformanceDisplay
}> = ({ ordersPerformance }) => {
  const data = useMemo(
    () => compileChartData(ordersPerformance),
    [ordersPerformance]
  )

  return <Doughnut options={DEFAULT_OPTIONS} data={data} />
}

const OrdersDoughnutLegend: React.FC<{
  ordersPerformance: OrdersPerformanceDisplay
}> = ({ ordersPerformance }) => {
  const { t } = useTranslation()

  const data = useMemo(
    () => compileLegendData(ordersPerformance),
    [ordersPerformance]
  )

  return (
    <div>
      <Text variant="nextTitle-3" gutter={16}>
        {t('performance.doughnut.legend.title', { count: data.accepted })}
      </Text>
      <ul className={Styles.doughnutLegend}>
        {data.types.map(value => (
          <li className={Styles.legendItem} key={value.label}>
            <span
              style={{ backgroundColor: value.backgroundColor }}
              className={Styles.colorIcon}
            />
            <Text variant="nextSubtitle" className={Styles.legendLabel}>
              {t(value.label)}
              {value.tooltipKey ? (
                <TooltipProvider>
                  <Tooltip>
                    <TooltipTrigger
                      type="button"
                      className={Styles.tooltipTrigger}
                      aria-label={t(value.tooltipKey)}>
                      <Info width={14} height={14} />
                    </TooltipTrigger>
                    <TooltipContent className={Styles.tooltipContent}>
                      {t(value.tooltipKey)}
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              ) : null}
              <Text variant="nextSubtitle" weight="bold" asChild>
                <span> • {value.count} </span>
              </Text>
              ({Number(value.percentage).toFixed(1)}%)
            </Text>
          </li>
        ))}
      </ul>
    </div>
  )
}

const OrdersDoughnut = {
  Chart: OrdersDoughnutChart,
  Legend: OrdersDoughnutLegend
}
export default OrdersDoughnut
